import React from "react";
import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Landing from "./components/pages/landing";
import Signup from "./components/pages/signup";
import Login from "./components/pages/login";
import Password from "./components/pages/password";
import Otp from "./components/pages/otp";
import Updated from "./components/pages/updated";
import Post from "./components/pages/post";
import Mybets from "./components/pages/mybets";
import Survey from "./components/pages/survey";

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Landing />} />
				<Route path="/signup" element={<Signup />} />
				<Route path="/signup/otp" element={<Otp signup={true} />} />
				<Route path="/login" element={<Login />} />
				<Route path="/password" element={<Password />} />
				<Route path="/otp" element={<Otp />} />
				<Route path="/updated" element={<Updated />} />
				<Route path="/post" element={<Post />} />
				<Route path="/mybets" element={<Mybets />} />
				<Route path="/survey" element={<Survey />} />
			</Routes>
		</Router>
	);
}

export default App;
